import { useQuery } from 'react-query';
import api from 'api';
import { EarningsComponentType } from 'components/SalaryComponents/types';
import type { ComponentHost } from 'components/SalaryComponents/types';

export const OT_SALARY_COMPONENTS_QUERY_KEY = 'ot-salary-components';

export type OtSalaryComponent = {
  id: string;
  name: string;
  description: string | undefined;
  includeInOtWages: boolean;
  componentSource?: ComponentHost;
};

export const mapToDropdownOptions = (item: EarningsComponentType): OtSalaryComponent => ({
  id: item.id,
  name: item.name,
  description: item.description,
  includeInOtWages: item.settings.behaviour?.otBehaviour?.includeInOtWages || false,
  componentSource: item.componentSource,
});

export function useOtSalaryComponents({
  onSuccess,
}: {
  onSuccess?: (data: OtSalaryComponent[]) => void;
} = {}) {
  return useQuery({
    queryKey: [OT_SALARY_COMPONENTS_QUERY_KEY],
    queryFn: () =>
      api.salaryComponents.queries.listSalaryComponents<EarningsComponentType>({
        category: 'EARNINGS_CATEGORY',
        status: 'COMPONENT_STATUS_ACTIVE',
      }),
    select: (response) => {
      const components = response.payrollListSalaryComponents.data.salaryComponents || [];
      return components.map(mapToDropdownOptions);
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
  });
}
